import api from './axios';

/**
 * Philippine bank holidays (Rule 74).
 *
 * These rows decide every payout's promised credit date, and several PH holidays
 * are proclaimed annually and movable — so this is an operator screen, not a
 * hardcoded list. A year that nobody loads is a year of wrong credit dates.
 */
export const listBankHolidays  = (params = {})        => api.get('/v1/admin/bank-holidays', { params });
export const createBankHoliday = (payload)            => api.post('/v1/admin/bank-holidays', payload);
export const updateBankHoliday = (holidayId, payload) => api.put(`/v1/admin/bank-holidays/${holidayId}`, payload);
export const deleteBankHoliday = (holidayId)          => api.delete(`/v1/admin/bank-holidays/${holidayId}`);
